var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-layout', {
    staticClass: "member-login",
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "background-layout"
  }, [_c('v-img', {
    attrs: {
      "src": "/images/ucardkorea/login-bg.png",
      "max-width": "100%",
      "height": "100%"
    }
  })], 1), _c('v-layout', {
    staticClass: "px-4 py-8 py-md-16",
    attrs: {
      "justify-center": "",
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "width": "100%",
      "height": "auto",
      "max-width": "800"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "pa-12px py-md-20px"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("아이디 찾기")])])]), _c('v-divider'), _c('div', {
    staticClass: "pa-12px pa-md-20px"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.find('username');
      }
    }
  }, [_vm._v("본인인증")])], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "pa-12px py-md-20px"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v("비밀번호 찾기")])])]), _c('v-divider'), _c('div', {
    staticClass: "pa-12px pa-md-20px"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "아이디",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.username,
      callback: function callback($$v) {
        _vm.username = $$v;
      },
      expression: "username"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.find('password');
      }
    }
  }, [_vm._v("본인인증")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('kcp-cert', {
    ref: "kcpCert"
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }